import { ChatDetailsResponse } from '@choco-admin/types';
import { Card, CardBody, Chip } from '@heroui/react';
import React from 'react';
import { FiShoppingCart, FiAlertTriangle } from 'react-icons/fi';

import { PageHeader } from '../PageHeader';

interface OrderGuideTabPanelProps {
  chatData: ChatDetailsResponse;
  chatId: string;
}

export const OrderGuideTabPanel: React.FC<OrderGuideTabPanelProps> = ({
  chatData,
  chatId,
}) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardBody className="space-y-2">
          <PageHeader
            title="Order Guide"
            subtitle="Manage products, pricing, and inventory settings for this chat."
            icon={<FiShoppingCart className="w-6 h-6 text-warning" />}
          />

          {/* LOX Migration Warning */}
          <Card className="border-warning-200 bg-warning-50">
            <CardBody>
              <div className="flex items-start gap-3">
                <FiAlertTriangle className="w-5 h-5 text-warning-600 mt-0.5 flex-shrink-0" />
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <Chip color="warning" variant="flat" size="sm">
                      Warning
                    </Chip>
                  </div>
                  <div className="space-y-1">
                    <p className="text-warning-800 font-medium">
                      This distributor has been migrated to LOX.
                    </p>
                    <p className="text-warning-700 text-sm">
                      Please use the available Retool app for viewing and
                      updating the Order guide for this chat.
                    </p>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </div>
  );
};
